module.exports = __webpack_public_path__ + "static/media/ic_search.fd7c90a9.svg";